
import { Options, Vue } from "vue-class-component";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src

const TOKEN_CACHE_KEY = "phi_spread_app_token";
const ALL_LOGIN_URL = "https://web.primafintech.ph/login-phi-app";

const hashTag = () => {
  const ret: { [k: string]: string } = {};
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.forEach((v, k) => {
    ret[k] = v;
  });

  if (!window.location.hash) {
    return ret;
  }
  const pos = window.location.hash.indexOf("?");
  if (pos == -1) {
    return ret;
  }
  const qs = window.location.hash.substring(pos + 1);
  const ps: string[] = qs.split("&");
  for (let i = 0; i < ps.length; i++) {
    const p = ps[i];
    if (!p) continue;
    const [k, v] = p.split("=");
    if (k && v !== undefined) {
      ret[k] = decodeURIComponent(v);
    }
  }
  return ret;
};

@Options({
  components: {
    HelloWorld,
  },
})
export default class HomeView extends Vue {
  appList: any[] = [];
  needLoading = 1;
  showLogoutConfirm = false;

  get hashTag(): { [k: string]: string } {
    return hashTag();
  }

  get isAll(): boolean {
    return this.hashTag["all"] === "1";
  }

  loadData() {
    fetch('/philippines_loan/tloan/my_country', {
      headers: new Headers({
          "Content-Type": "application/json",
        }),
    }).then((res) => {
          return res.json();
        }).then(res => {
            if (res.ret?.countryCode !== 'CN') {
                this.needLoading = 0;
                this.checkToken();
            } else {
                this.needLoading = -1;
                // this.needLoading = 0;
                // this.checkToken();
            }
        }).catch(err => {
            this.loadData();
        })
  }
  
  mounted() {
    
    this.loadData();

    // const token = 'ZZtolppub2hoY2ebap2ebp+aaZ5rb2heZGVml5uXmWCHnpLf24tpe5J3pdKjsLyf4Myomn+HZ5ildnfAy9XfZHvck8C0b3yah4Wsog==';
    console.log(this.hashTag);
    
  }

  checkToken() {
    const linkToken = this.hashTag["token"];
    const isAll = this.isAll;
    if (linkToken && linkToken.length > 0) {
      localStorage.setItem(TOKEN_CACHE_KEY, linkToken);
    }

    const token =
      linkToken && linkToken.length > 0
        ? linkToken
        : isAll
          ? localStorage.getItem(TOKEN_CACHE_KEY) || ""
          : "";

    if (token && token.length > 0 && this.needLoading === 0) {
      fetch("/philippines_loan/tloan/spread_app", {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          token: token,
        }),
        body: isAll ? JSON.stringify({ all: 1 }) : undefined,
      })
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          const { app_name } = this.hashTag;
          this.appList = res.ret.filter((e: any) => e.app_name != app_name);
        });
    } else if (this.needLoading === 0 && isAll) {
      window.location.href = ALL_LOGIN_URL
    } else if (this.needLoading === 0) {
      if (window.location.href.includes("a.")) {
        window.location.href = 'https://p.prima-loan.ph/login-phi-app'
      } else {
        window.location.href = 'https://p.lightkredit.ph/login-phi-app'
      }
      
    }
  }

  logout() {
    localStorage.removeItem(TOKEN_CACHE_KEY);
    window.location.href = ALL_LOGIN_URL;
  }
}
